import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {


  submitted = false
  username = ""
  oldPass = ""
  newPass = ""
  confirmPass = ""
  tokenId = ""
  userId = ""

  constructor(
    private util: UtilService,
    private apiService: ApiService) { }

  ngOnInit() {
    let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.username = cookieData["username"]
    this.userId = cookieData["userId"]
  }

  async changePassword() {
    this.submitted = true
    if (this.username.trim().length > 0 && this.oldPass.length > 0 && this.newPass.length > 0 && this.newPass == this.confirmPass
      && this.passwordValidation()) {
      this.util.ShowWaiting(true)

      let guidReq: any = {
        username: this.username
      }
      let guidRes: any = await this.apiService.postCustom("Crm", "InsertChangeCallCenterPassToken", guidReq);
      if (this.util.isSuccessResponse(guidRes) && guidRes.token_id != "") {
        this.tokenId = guidRes.token_id
        guidReq = {
          dpa_customwebuserid: this.userId,
          guid: guidRes.token_id
        }

        guidRes = await this.apiService.post("crmservice", "updateCallcenterGuid", guidReq);
        if (this.util.isSuccessResponse(guidRes) && guidRes.RESMSG == "SUCCESS") {
          
          if (this.oldPass == this.newPass){
            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม")
          }
          else {
            let req: any = {
              "mode": 1,
              "oldPassword": this.oldPass,
              "newPassword": this.newPass,
              guid: this.tokenId
            }
            var res: any = await this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req);
            if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
              this.clear()
              this.util.SuccessDialog("เปลี่ยน Password สำเร็จ")
            }
            else {
              this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
            }
          }

        }
        else {
          this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
        }
      }
      else {
        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
      }

      this.util.ShowWaiting(false)
    }
  }

  clear() {
    this.submitted = false
    this.oldPass = ""
    this.newPass = ""
    this.confirmPass = ""
  }

  close() {
    window.close()
  }

  passwordValidation(){
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass)
  }
}



// WEBPACK FOOTER //
// ./src/app/account/forgot-password/forgot-password.component.ts